import * as Yup from 'yup'

import { onlyNumbers } from 'helpers/validations'

export const recoveryValidationSchema = translations =>
  Yup.object().shape({
    credential: Yup.string().when('$credentialToRecover', {
      is: 'password',
      then: schema =>
        schema
          .email(translations('agreements.login-validation.username-pattern'))
          .required(translations('agreements.login-validation.username-empty')),
      otherwise: schema =>
        schema
          .test(
            'document-test',
            translations('agreements.login-validation.document-pattern'),
            value => new RegExp(onlyNumbers).test(value)
          )
          .required(translations('agreements.login-validation.document-empty'))
    })
  })
